import React, { useState, useMemo } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useSelectedCompany } from '../../../hooks';
import FingoDialog from '../FingoDialog';
import SettlementSummaryTab from './SettlementTab';
import PortfolioTab from './PortfolioTab';
import { CLIENT_SUMMARY_OPTIONS } from '../../../constants/client-document-summaries';

const DownloadClientSummariesDialog = ({
  customCompany,
  open,
  onClose,
  client,
  product,
  onlyTab,
}) => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState(CLIENT_SUMMARY_OPTIONS.PORTFOLIO);
  const selectedCompany = useSelectedCompany();
  const companyId = customCompany !== null ? customCompany : selectedCompany?.id;

  const tabsValue = onlyTab ?? selectedTab;

  const selectedTabComponent = useMemo(() => {
    if (tabsValue === CLIENT_SUMMARY_OPTIONS.SETTLEMENTS) {
      return <SettlementSummaryTab customCompany={companyId} />;
    }

    return (
      <PortfolioTab
        customCompany={companyId}
        product={product}
        client={client}
      />
    );
  }, [tabsValue, companyId, product, client]);

  const tabsToRender = useMemo(() => {
    const filteredOptions = onlyTab ? [onlyTab] : Object.values(CLIENT_SUMMARY_OPTIONS);
    return filteredOptions.map((tabValue) => (
      <Tab
        key={tabValue}
        label={tabValue === CLIENT_SUMMARY_OPTIONS.PORTFOLIO ? 'Cartera' : 'Liquidaciones'}
        value={tabValue}
      />
    ));
  }, [onlyTab]);

  return (
    <FingoDialog
      open={open}
      handleClose={onClose}
      title="Descarga de información"
      maxWidth="lg"
      fullWidth
    >
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={tabsValue}
          onChange={(_, value) => setSelectedTab(value)}
          variant="fullWidth"
          sx={{
            width: '100%',
            '& .MuiTab-root': {
              fontSize: '20px',
              fontWeight: 700,
              color: theme.palette.gray.A400,
              '&.Mui-selected': {
                color: theme.palette.primary.main,
                borderBottom: `3px solid ${theme.palette.primary.main}`,
              },
              '&:not(.Mui-selected)': {
                borderBottom: `3px solid ${theme.palette.gray.A300}`,
              },
            },
          }}
        >
          {tabsToRender}
        </Tabs>
      </Box>
      <Box sx={{ padding: '32px 10px' }}>
        {selectedTabComponent}
      </Box>
    </FingoDialog>
  );
};

DownloadClientSummariesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  product: PropTypes.string.isRequired,
  customCompany: PropTypes.number,
  client: PropTypes.bool,
  onlyTab: PropTypes.string,
};

DownloadClientSummariesDialog.defaultProps = {
  customCompany: null,
  client: true,
  onlyTab: undefined,
};

export default DownloadClientSummariesDialog;
